export type StageStatus = 'completed' | 'active' | 'planned';
export type StageMediaType = 'photo' | 'video' | 'tour360';

export type StageMediaItem = {
  id: string;
  title: string;
  type: StageMediaType;
  description: string;
  src: string;
  thumbnail: string;
};

export type ProjectStage = {
  id: string;
  name: string;
  shortName: string;
  period: string;
  status: StageStatus;
  description: string;
  deliverables: string[];
  media: StageMediaItem[];
};

export const projectStages: ProjectStage[] = [
  {
    id: 'stage-1',
    name: 'Etapa 1: Infraestructura Base',
    shortName: 'Etapa 1',
    period: 'Q3 2026',
    status: 'active',
    description:
      'Desarrollo de vialidad principal, redes criticas y adecuaciones para la primera ocupacion empresarial.',
    deliverables: ['Vialidad interna', 'Energia y agua operativa', 'Primeras naves habilitadas'],
    media: [
      {
        id: 's1-photo-1',
        title: 'Avance de infraestructura',
        type: 'photo',
        description: 'Registro fotografico de las vias internas y obras de soporte.',
        src: 'https://images.unsplash.com/photo-1619070284836-e850273d69ac?auto=format&fit=crop&w=1600&q=80',
        thumbnail: 'https://images.unsplash.com/photo-1619070284836-e850273d69ac?auto=format&fit=crop&w=640&q=80',
      },
      {
        id: 's1-video-1',
        title: 'Recorrido de obra',
        type: 'video',
        description: 'Video de avance de sitio para seguimiento ejecutivo.',
        src: 'https://www.youtube.com/embed/aqz-KE-bpKQ',
        thumbnail: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=640&q=80',
      },
      {
        id: 's1-360-1',
        title: 'Vista 360 del lote',
        type: 'tour360',
        description: 'Perspectiva inmersiva para validar accesos y ubicacion.',
        src: 'https://www.youtube.com/embed/3xQ9fL4Y4uM',
        thumbnail: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&w=640&q=80',
      },
      {
        id: 's1-photo-2',
        title: 'Plataforma de carga',
        type: 'photo',
        description: 'Zona operativa para movimiento de carga y descarga.',
        src: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1600&q=80',
        thumbnail: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=640&q=80',
      },
      {
        id: 's1-photo-3',
        title: 'Acceso principal',
        type: 'photo',
        description: 'Control de ingreso vehicular y peatonal de la etapa 1.',
        src: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=1600&q=80',
        thumbnail: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=640&q=80',
      },
      {
        id: 's1-video-2',
        title: 'Logistica diaria',
        type: 'video',
        description: 'Resumen audiovisual de operacion y maniobra interna.',
        src: 'https://www.youtube.com/embed/ScMzIvxBSi4',
        thumbnail: 'https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=640&q=80',
      },
      {
        id: 's1-360-2',
        title: 'Recorrido 360 patio',
        type: 'tour360',
        description: 'Vista inmersiva del patio de operaciones activo.',
        src: 'https://www.youtube.com/embed/1La4QzGeaaQ',
        thumbnail: 'https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=640&q=80',
      },
      {
        id: 's1-photo-4',
        title: 'Nave habilitada',
        type: 'photo',
        description: 'Registro de nave lista para primera ocupacion.',
        src: 'https://images.unsplash.com/photo-1494412574643-ff12f4b43b5f?auto=format&fit=crop&w=1600&q=80',
        thumbnail: 'https://images.unsplash.com/photo-1494412574643-ff12f4b43b5f?auto=format&fit=crop&w=640&q=80',
      },
    ],
  },
  {
    id: 'stage-2',
    name: 'Etapa 2: Expansion Operativa',
    shortName: 'Etapa 2',
    period: 'Q1 2027',
    status: 'planned',
    description:
      'Ampliacion de capacidad logistica y servicios de soporte para absorber crecimiento de la demanda regional.',
    deliverables: ['Nuevos modulos de almacen', 'Patios de maniobra ampliados', 'Centro de soporte 24/7'],
    media: [],
  },
  {
    id: 'stage-3',
    name: 'Etapa 3: Consolidacion Regional',
    shortName: 'Etapa 3',
    period: 'Q4 2027',
    status: 'planned',
    description:
      'Consolidacion del ecosistema de zona franca con soluciones avanzadas de conectividad y eficiencia.',
    deliverables: ['Hub multimodal', 'Automatizacion de procesos', 'Plataforma de analitica operativa'],
    media: [],
  },
];

export const currentStage = projectStages.find((stage) => stage.status === 'active') ?? projectStages[0];
